// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604210058/js/" + chunkId + "." + {"44":"aa6c8b02","225":"482608c5","481":"d56f19dd","486":"7e29ccd1","770":"5a9372bf"}[chunkId] + ".0.9859322096068803.chunk.js";
};